import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

const restaurantScoped = (roles) => rule(roles, { scope: SCOPES.RESTAURANT });

const OPERATION_ROLES = lud(R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW);

export const operationPermissions = {
  view: "operation.view",
  action: {
    admin: "operation.action.admin",
    statusUpdate: "operation.action.status.update",
    manage: "operation.action.manage",
    clientApprovalView: "operation.action.clientApproval.view",
    // Approve a campaign on behalf of the restaurant (backend: DELEGATE_APPROVER_ROLES).
    approveOnBehalf: "operation.action.approveOnBehalf",
  },
  campaign: { use: "operation.campaign.use", edit: "operation.campaign.edit" },
};

// "operation.campaign.use" / "operation.campaign.edit" belong to the campaign-actions
// box on the Operations page; "campaign.request.create" (campaignRecord.js) belongs to
// the Campaigns page. They are intentionally separate (NA-024) and currently granted to
// the same roles; change one without the others only on purpose.
export const operationGrants = {
  "operation.view": rule([...OPERATION_ROLES,R.FA]),
  // admin-only columns / row actions in the operations table
  "operation.action.admin": restaurantScoped(lud(R.AM, R.DMM)),
  "operation.action.status.update": restaurantScoped(lud(R.DMM, R.AM)),
  // approve / reject / complete actions on an action card
  "operation.action.manage": restaurantScoped(lud(R.DMM, R.AM, R.STORE_L)),
  // every operations viewer except fa sees the client-approval controls
  "operation.action.clientApproval.view": rule(OPERATION_ROLES),
  // only am and dmm (explicit business decision), for the restaurants they reach
  "operation.action.approveOnBehalf": restaurantScoped([R.AM, R.DMM]),
  // the campaign-actions box (server decides what each role may do)
  "operation.campaign.use": restaurantScoped(lud(R.DMM, R.AM, R.STORE_L, R.STORE)),
  "operation.campaign.edit": restaurantScoped(lud(R.DMM, R.AM, R.STORE_L, R.STORE)),
};

